import styled from "@emotion/styled";
import { UNSELECTABLE_TEXT } from "../../styles/styles";
import { css } from "@emotion/react";
import { BLACK } from "../../styles/colors";

export const Group = styled("div")``;

export const GroupHeader = styled("div")`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  padding: 6px 2px;
  cursor: pointer;
  color: ${BLACK};
`;

export const ExpandImage = css`
  width: 15px;
  height: 15px;
  cursor: pointer;
  ${UNSELECTABLE_TEXT}
`;

export const ExpandButton = css`
  margin-right: 5px;
  opacity: 75%;
  border: none;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    opacity: 100%;
  }
`;

export const Check = styled('label')<{ columns: string }>`
  display: grid;
  grid-template-columns: ${({ columns }) => columns};
  align-items: center;
  column-gap: 10px;

  font-size: 14px;
  color: ${BLACK};
  cursor: pointer;
  user-select: none;
  line-height: 1;
  padding: 1px 8px;

  input {
    margin: 0;
    flex-shrink: 0;
    transform: translateY(-1px);
  }
`;
